import { HybridCloudService } from '@qdrant/qdrant-cloud-public-api/hybrid/v1';
import { createFileRoute, lazyRouteComponent } from '@tanstack/react-router';
import { assertRpcPermissions } from '@/api/permissions';
import { head } from '@/router/Head';

export const Route = createFileRoute(
  '/_authenticated/_dashboard/accounts/$accountId/hybrid-cloud/$hybridCloudEnvId/onboarding/connection',
)({
  staticData: {
    title: ['Hybrid Cloud', 'Onboarding', 'Connection'],
  },
  // The step writes to the environment, so it is gated on the same method its form calls. The parent
  // also redirects a reader away from an unfinished environment, but that rule is about the stage; this
  // one is the route's own, and states it where the step lives — like the `configuration` sibling.
  beforeLoad: ({ context: { queryClient }, params: { accountId } }) => {
    assertRpcPermissions([HybridCloudService.method.updateHybridCloudEnvironment], { queryClient, accountId });
  },
  head,
  component: lazyRouteComponent(() => import('./connection.component'), 'HybridCloudOnboardingConnectionComponent'),
  pendingComponent: lazyRouteComponent(
    () => import('./connection.component'),
    'HybridCloudOnboardingConnectionPendingComponent',
  ),
});
